// app/src/lib/brand-visual.js — PURE presentation helpers for real brand rows (CREATE-2). The
// server's brand shape carries no avatar letter or gradient (those were demo.js chrome), so the
// UI derives them deterministically from the id/name — same brand always gets the same look.

const GRADIENTS = ['var(--poster-mint-flat)', 'var(--poster-violet)', 'var(--poster-coral)', 'var(--poster-amber)', 'var(--poster-teal)'];
const ACCENTS = ['coral', 'violet', 'mint', 'tangerine'];

function hash(s) {
  let h = 0;
  for (let i = 0; i < String(s || '').length; i++) h = (h * 31 + String(s).charCodeAt(i)) >>> 0;
  return h;
}

export function brandLetter(brand) {
  const n = (brand && brand.name) || '';
  const c = n.trim().charAt(0);
  return c ? c.toUpperCase() : '·';
}

export function brandGradient(brand) {
  return GRADIENTS[hash((brand && (brand.id || brand.name)) || '') % GRADIENTS.length];
}

// a stable accent NAME (coral/violet/mint/tangerine) for a voice chip at a given index — the
// stored voice.accent is free text (or empty on save-as-brand prefill), so the chip colour is
// presentation, cycled by position, never trusted to be a CSS var.
export function accentAt(i) {
  return ACCENTS[((i % ACCENTS.length) + ACCENTS.length) % ACCENTS.length];
}
